export const veeduriaState = {
    padre: {},
    estudiante: {},
    preguntas: [],
    id: 0,
    isLoading: false,
    message: '',
    severity: ''
}